import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Star } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Stars = ({ value, size = 14 }) => (
  <span className="inline-flex items-center gap-0.5">
    {[1, 2, 3, 4, 5].map((s) => (
      <Star key={s} size={size} className={value >= s ? 'fill-amber-400 text-amber-400' : 'text-gray-300'} />
    ))}
  </span>
);

export const RatingsSummary = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/testimonials/ratings-summary`)
      .then((res) => setData(res.data))
      .catch(() => {});
  }, []);

  if (!data || data.count === 0) return null;

  return (
    <Card className="mb-6" data-testid="ratings-summary-card">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-base">
          <Star size={18} className="fill-amber-400 text-amber-400" />
          Customer Ratings
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="flex items-center gap-3 mb-3">
          <span className="text-3xl font-bold text-gray-900" data-testid="avg-rating">{data.average.toFixed(1)}</span>
          <div>
            <Stars value={Math.round(data.average)} size={16} />
            <p className="text-xs text-gray-500">{data.count} rating{data.count !== 1 ? 's' : ''}</p>
          </div>
        </div>
        <div className="space-y-2">
          {data.recent.map((r, i) => (
            <div key={i} className="border-t pt-2 first:border-t-0" data-testid={`recent-rating-${i}`}>
              <div className="flex items-center justify-between gap-2">
                <p className="text-sm font-semibold text-gray-800 truncate">{r.customer_name}</p>
                <Stars value={r.rating} />
              </div>
              {r.comment && <p className="text-xs text-gray-600 mt-0.5">"{r.comment}"</p>}
              <p className="text-[10px] text-gray-400">{r.do_number}{r.rated_at ? ` · ${r.rated_at.slice(0, 10)}` : ''}</p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
